import {library} from "@fortawesome/fontawesome-svg-core";
import {IconDefinition, IconLookup, IconName} from "@fortawesome/fontawesome-common-types";
import * as faIcons from "@fortawesome/free-solid-svg-icons";
import fullIconList from "./font-awesome-icons.json";

export class FontAwesomeService {
    public presetIcons: IconDefinition[] = [faIcons.faUsers, faIcons.faUser, faIcons.faTrophy, faIcons.faSuitcaseMedical, faIcons.faStore, faIcons.faStar, faIcons.faSeedling, faIcons.faScrewdriverWrench, faIcons.faSackDollar, faIcons.faRocket, faIcons.faPlus, faIcons.faPlane, faIcons.faPizzaSlice, faIcons.faPeopleGroup, faIcons.faPencil, faIcons.faPaperclip, faIcons.faNewspaper, faIcons.faNetworkWired, faIcons.faMugHot, faIcons.faLocationDot, faIcons.faLink, faIcons.faLightbulb, faIcons.faLaptop, faIcons.faHouse, faIcons.faHeart, faIcons.faGraduationCap, faIcons.faGlobe, faIcons.faGem, faIcons.faGear, faIcons.faFolderOpen, faIcons.faFileLines, faIcons.faFaceSmile, faIcons.faEnvelope, faIcons.faEarthEurope, faIcons.faDroplet, faIcons.faDisplay, faIcons.faCookieBite, faIcons.faCompass, faIcons.faComment, faIcons.faCoins, faIcons.faCloud, faIcons.faCircleQuestion, faIcons.faCircleNodes, faIcons.faCircleCheck, faIcons.faCircle, faIcons.faCheck, faIcons.faChartSimple, faIcons.faChartPie, faIcons.faChartLine, faIcons.faChartColumn, faIcons.faChampagneGlasses, faIcons.faCartShopping, faIcons.faCarrot, faIcons.faCarSide, faIcons.faCalendarDays, faIcons.faBurst, faIcons.faBullhorn, faIcons.faBuilding, faIcons.faBriefcase, faIcons.faBoxArchive, faIcons.faBookOpen, faIcons.faBoltLightning, faIcons.faArrowUpRightFromSquare, faIcons.faAnchor, faIcons.faAtom];
    public defaultNoIcon: IconDefinition = faIcons.faNotdef;

    constructor() {
        library.add(this.defaultNoIcon, faIcons.fas);
    }

    private static parseIcon(iconName: string): IconLookup {
        return {prefix: "fas", iconName: iconName as IconName};
    }

    public icon(iconName: string): IconLookup {
        const parsedIconName = FontAwesomeService.parseIcon(iconName);
        return parsedIconName ?? this.defaultNoIcon;
    }

    public searchIcons(searchTerm: string): string[] {
        return fullIconList.filter(iconName => iconName.toLowerCase().includes(searchTerm.toLowerCase()))
    }
}

export const fontAwesomeService: FontAwesomeService = new FontAwesomeService();
